module.exports = __webpack_public_path__ + "img/antes_despues_202.5bc52626.png";